import moment from 'moment';

// The PD APIs return dates as ISO (YYYY-MM-DD); every PD screen displays them
// as 13-MAR-2026. Shared by the Documents tab's Upload Date column and the
// review window's context bar so the same date never renders two ways.
// Anything unparseable is shown as-is rather than blanked, so a value the
// backend sends in an unexpected shape stays visible instead of disappearing.
export const formatDisplayDate = (value) => {
  if (!value) return '';
  const m = moment(value, ['YYYY-MM-DD', moment.ISO_8601], true);
  return m.isValid() ? m.format('DD-MMM-YYYY').toUpperCase() : String(value);
};

// The FSD writes the requiring-review count zero-padded to two digits ("Fields
// that require review - 02"). Non-numeric input falls back to 0 rather than
// rendering "undefined" into the label if the payload ever arrives incomplete.
export const padCount = (n) => String(Number(n) || 0).padStart(2, '0');
